<template>
  <Content class="overview">
    <FlexContainer>
      <FlexItem :grow="true">
        <FlexContainer justifyContent="start">
          <FlexItem padding="normal">
            <Field label="Live">
              <SelectInput
                v-model="dealLive"
                :options="liveOptions"
                placeholder="All"
              />
            </Field>
          </FlexItem>
          <FlexItem padding="normal">
            <Field label="Product" type="black">
              <TextInput
                v-model.trim="dealFilter"
                placeholder="Brand, name or colour"
              />
            </Field>
          </FlexItem>
        </FlexContainer>
        <table>
          <tr>
            <th>Live</th>
            <th></th>
            <th>Deal</th>
            <th>Price</th>
            <th>Publisher</th>
          </tr>
          <tr :key="index" v-for="(deal, index) in orderedDeals">
            <td>
              <i
                v-if="deal.live"
                class="fas fa-badge-check u__color--success"
                @click="toggleDealLive(deal.id)"
              ></i>
              <i
                v-else
                class="fal fa-badge u__color--success"
                @click="toggleDealLive(deal.id)"
              ></i>
            </td>
            <td>
              <ImageItem
                :src="getProductImage(deal.productId)"
                width="24px"
                height="24px"
              />
            </td>
            <td>{{ getProductName(deal.productId) }}</td>
            <td>£{{ deal.price }}</td>
            <td>
              <ImageItem
                :src="getPublisherImage(deal.publisherId)"
                width="24px"
              />
            </td>
            <td width="10%">
              <FlexContainer>
                <FlexItem>
                  <ButtonIcon
                    type="secondary"
                    icon="edit"
                    size="small"
                    @onClick="editDeal(deal.id)"
                  />
                </FlexItem>
                <FlexItem>
                  <IconLink
                    type="tertiary"
                    icon="search"
                    size="small"
                    :href="deal.url"
                    target="_blank"
                  />
                </FlexItem>
                <FlexItem>
                  <ButtonIcon
                    type="primary"
                    icon="trash"
                    size="small"
                    @onClick="
                      confirmDeleteDeal(
                        deal.id,
                        `${getProductName(deal.productId)}`
                      )
                    "
                  />
                </FlexItem>
              </FlexContainer>
            </td>
          </tr>
        </table>
      </FlexItem>
    </FlexContainer>
    <Modal :show="showModal.peakDeal" @closeModal="showModal.peakDeal = false">
      <div slot="header">
        <h2>Peak Deal</h2>
      </div>
      <div slot="body"></div>
    </Modal>
    <Modal :show="showModal.deal" @closeModal="showModal.deal = false">
      <div slot="header">
        <h2>{{ formMode.deal }} Deal</h2>
      </div>
      <div slot="body">
        <DealForm
          :mode="formMode.deal"
          :dealId="currentDeal"
          :productId="currentProduct"
          @onSubmit="onSubmit('deal')"
        />
      </div>
    </Modal>
    <Modal :show="showModal.product" @closeModal="showModal.product = false">
      <div slot="header">
        <h2>{{ formMode.product }} Product</h2>
      </div>
      <div slot="body">
        <ProductForm
          :mode="formMode.product"
          :productId="currentProduct"
          @onSubmit="onSubmit('product')"
        />
      </div>
    </Modal>
    <Modal :show="showModal.category" @closeModal="showModal.category = false">
      <div slot="header">
        <h2>Edit Category</h2>
      </div>
      <div slot="body">
        <CategoryForm
          :categoryId="currentCategory"
          @onSubmit="onSubmit('category')"
        />
      </div>
    </Modal>
    <Modal
      :show="showModal.publisher"
      @closeModal="showModal.publisher = false"
    >
      <div slot="header">
        <h2>Edit Publisher</h2>
      </div>
      <div slot="body">
        <PublisherForm
          :publisherId="currentPublisher"
          @onSubmit="onSubmit('publisher')"
        />
      </div>
    </Modal>
    <Modal :show="showModal.delete" @closeModal="showModal.delete = false">
      <div slot="header">
        <h2>Are you sure you want to delete {{ currentDeletionItem.name }}?</h2>
      </div>
      <div slot="footer">
        <Button type="secondary" @onClick="showModal.delete = false"
          >Cancel</Button
        >
        <Button
          v-show="currentDeletionItem.type === 'deal'"
          type="primary"
          @onClick="
            deleteDeal(currentDeletionItem.id);
            showModal.delete = false;
          "
          >Confirm</Button
        >
        <Button
          v-show="currentDeletionItem.type === 'product'"
          type="primary"
          @onClick="
            deleteProduct(currentDeletionItem.id);
            showModal.delete = false;
          "
          >Confirm</Button
        >
      </div>
    </Modal>
  </Content>
</template>

<script>
import { orderBy, filter, isEmpty } from 'lodash';
import { mapState, mapActions, mapGetters } from 'vuex';
import DealForm from '@/components/admin/DealForm';
import ProductForm from '@/components/admin/ProductForm';
import CategoryForm from '@/components/admin/CategoryForm';
import PublisherForm from '@/components/admin/PublisherForm';

export default {
  data: function() {
    return {
      currentTab: 0,
      tabs: [
        { href: '#deals', text: 'Deals', onClick: this.onChangeTab },
        { href: '#products', text: 'Products', onClick: this.onChangeTab },
        { href: '#categories', text: 'Categories', onClick: this.onChangeTab },
        { href: '#publishers', text: 'Publishers', onClick: this.onChangeTab },
      ],
      showModal: {
        deal: false,
        product: false,
        category: false,
        publisher: false,
        delete: false,
      },
      formMode: {
        deal: 'add',
        product: 'add',
        category: 'add',
        publisher: 'add',
      },
      currentDeal: null,
      currentProduct: null,
      currentCategory: null,
      currentPublisher: null,
      currentDeletionItem: {},
      productFilter: '',
      dealFilter: '',
      dealLive: null,
      liveOptions: [
        {
          text: 'Live',
          value: true,
        },
        {
          text: 'Not Live',
          value: false,
        },
      ],
    };
  },
  components: {
    DealForm,
    ProductForm,
    CategoryForm,
    PublisherForm,
  },
  computed: {
    ...mapState({
      deals: (state) => state.deal.deals,
      products: (state) => state.product.products,
      categories: (state) => state.category.categories,
      publishers: (state) => state.publisher.publishers,
    }),
    ...mapGetters({
      getPublisher: 'publisher/getPublisher',
      getPublisherImage: 'publisher/getImage',
      getCategoryName: 'category/getName',
      getProduct: 'product/getProduct',
      getProductImage: 'product/getImage',
      getProductDealsCount: 'deal/getProductDealsCount',
      getProductDealsPublisherImages: 'deal/getProductDealsPublisherImages',
    }),
    orderedDeals() {
      let deals = filter(this.deals, (deal) => {
        if (this.dealFilter.length === 0) {
          return true;
        }

        let product = this.getProduct(deal.productId);
        let productFullName = `${product.brand} ${product.name} ${product.edition} ${product.colour}`;

        return (
          productFullName
            .toLowerCase()
            .indexOf(this.dealFilter.toLowerCase()) !== -1
        );
      });

      deals = filter(deals, (deal) => {
        if (isEmpty(this.dealLive)) {
          return true;
        }

        if (typeof deal.live === 'undefined') {
          return false;
        }

        return deal.live.toString() === this.dealLive;
      });

      return orderBy(
        deals,
        [
          'updated_at',
          (deal) => {
            let product = this.getProduct(deal.productId);

            return product ? product.brand : null;
          },
          (deal) => {
            let product = this.getProduct(deal.productId);

            return product ? product.name : null;
          },
        ],
        ['desc', 'asc', 'asc']
      );
    },
    orderedProducts() {
      let products = filter(this.products, (product) => {
        if (this.productFilter.length === 0) {
          return true;
        }

        let productFullName = `${product.brand} ${product.name} ${product.edition} ${product.colour}`;
        return (
          productFullName
            .toLowerCase()
            .indexOf(this.productFilter.toLowerCase()) !== -1
        );
      });
      return orderBy(products, ['brand', 'name'], ['asc', 'asc']);
    },
  },
  methods: {
    ...mapActions({
      toggleProductLive: 'product/toggleLive',
      toggleDealLive: 'deal/toggleLive',
      deleteDeal: 'deal/deleteDeal',
      deleteProduct: 'product/deleteProduct',
    }),
    onChangeTab(index) {
      this.currentTab = index;
    },
    onSubmit(type) {
      setTimeout(() => {
        this.showModal[type] = false;
      }, 2000);
    },
    createDealFromProduct(id) {
      this.formMode.deal = 'add';
      this.currentProduct = id;
      this.currentDeal = null;
      this.showModal.deal = true;
    },
    duplicateProduct(id) {
      this.formMode.product = 'duplicate';
      this.currentProduct = id;
      this.showModal.product = true;
    },
    editDeal(id) {
      this.formMode.deal = 'edit';
      this.currentDeal = id;
      this.showModal.deal = true;
    },
    peakDeal(url) {
      this.currentDeal = url;
      this.showModal.peakDeal = true;
    },
    editProduct(id) {
      this.formMode.product = 'edit';
      this.currentProduct = id;
      this.showModal.product = true;
    },
    editCategory(id) {
      this.currentCategory = id;
      this.showModal.category = true;
    },
    editPublisher(id) {
      this.currentPublisher = id;
      this.showModal.publisher = true;
    },
    confirmDeleteProduct(id, name) {
      this.showModal.delete = true;
      this.currentDeletionItem = {
        type: 'product',
        id,
        name,
      };
    },
    confirmDeleteDeal(id, name) {
      this.showModal.delete = true;
      this.currentDeletionItem = {
        type: 'deal',
        id,
        name,
      };
    },
    deletePublisher() {},
    getProductName(productId) {
      let product = this.getProduct(productId);

      if (product) {
        return `${product.brand} ${product.name} ${product.edition || ''} ${
          product.colour
        }`;
      }
      return 'Name not found';
    },
  },
  mounted() {
    if (this.$route.hash) {
      this.currentTab = this.tabs
        .map((tab) => tab.href)
        .indexOf(this.$route.hash);
    }
  },
};
</script>

<style lang="scss" scoped>
.tab {
  background: $white;
  padding: $padding;
}

.results-info {
  padding: $padding-small 0;
  font-weight: 400;
}

table {
  width: 100%;

  tr:nth-of-type(2n) {
    background: $gray-lightest;
  }

  th,
  td {
    padding: 0.8rem;
    vertical-align: middle;
  }

  th {
    font-weight: 400;
  }
}
</style>
